import '@lm-nx-frontend/lm-inf-ui';

declare module '@lm-nx-frontend/lm-inf-ui' {
  export const enum LAUNCH_CALLER {
    CLEAR_CART = 'CLEAR_CART',
    ADDED_TO_CART = 'ADDED_TO_CART',
  }
}
